export const COOKIE_NAMES = {
  REFRESH_TOKEN: "refresh_token",
  ACCESS_TOKEN: "access_token",
  REDIRECT_URL: "redirect_url",
}

export const EXTERNAL_COOKIE_NAMES = {
  ACCESS_TOKEN: "external_access_token",
  REDIRECT_URL: "redirect_url",
}
